import * as yup from 'yup'

const schema = yup.object().shape({
  content: yup.string().when('hasSend', {
    is: false,
    then: (schemaItem) => schemaItem.required(),
  }),
  attachments: yup.mixed().fileUpload(),
  hasSend: yup.boolean().required(),
})

export default schema
